import React from 'react';
import PropTypes from 'prop-types';

import TextField from '../../../../components/forms/TextField';

export const AgeInputComponent = React.forwardRef(({
  hasError,
  helperText,
  onBlur,
  onChange,
  themeType,
  value,
}, ref) => (
  <TextField
    hasError={hasError}
    helperText={helperText}
    id="in-page-lead-form-age-input"
    labelText='Age'
    maxLength={3}
    name='age'
    onBlur={onBlur}
    onChange={onChange}
    ref={ref}
    required={true}
    themeType={themeType}
    value={value} />
));

AgeInputComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default AgeInputComponent;
